// src/utils/leetcode.js

/**
 * Extracts the LeetCode username from a username or profile URL.
 * @param {string} input - Username or LeetCode profile URL.
 * @returns {string|null} - Extracted username or null if invalid.
 */
export function extractLeetCodeUsername(input) {
  if (!input) return null;
  input = input.trim();
  if (!input.includes("leetcode.com")) {
    return input;
  }
  try {
    const url = new URL(input.startsWith("http") ? input : `https://${input}`);
    const parts = url.pathname.split("/").filter(Boolean);
    if (parts[0] === "u" && parts[1]) return parts[1];
    if (parts[0]) return parts[0];
    return null;
  } catch {
    return null;
  }
}

/**
 * Validates the LeetCode username using the GraphQL query.
 * @param {function} validateLeetCode - Apollo lazy query function.
 * @param {string} username - The extracted username.
 * @returns {Promise<{valid: boolean, error?: string}>}
 */
export async function validateLeetCodeUsername(validateLeetCode, username) {
  if (!username) return { valid: false, error: "Username is required." };
  if (username.length < 3 || username.length > 40) {
    return { valid: false, error: "Enter valid user name" };
  }
  try {
    const { data, error } = await validateLeetCode({ variables: { username } });
    if (error || !data?.leetcodeData?.matchedUser?.username) {
      return { valid: false, error: "LeetCode username not found. Please enter a valid username." };
    }
    return { valid: true };
  } catch {
    return { valid: false, error: "Unable to verify LeetCode username. Please check and try again." };
  }
}
